import { buttonName } from '../board/boardItem'
import { PromotionList } from './_components/promotionList'
import { PromotionTitle } from './promotionItem'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@/components'
import { useAppSelector } from '@/redux/hooks'
import { useDialog } from '@/context/dialogContext'
import MenuInfo from '../menu/menuInfo'
import { MenuHeader } from '../menu/menuHeader'
import { useRef, useState } from 'react'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const Promotion: React.FC = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const navigate = useNavigate()
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const { showAlert } = useDialog()
  const { isMobile, isTablet, isDesktop } = useResponsive()

  return (
    <>
      <SEO
        title="정보"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/promotion"
      />
      <div style={{ padding: isMobile ? '0 16px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={true}
          menuInfoRef={menuInfoRef}
          loginRequired={true}
          iconActive={hasMenuInfo}
        />
      </div>
      <div>
        <PromotionList />
        <div ref={menuInfoRef}>
          <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
        </div>
      </div>
    </>
  )
}

export default Promotion
